<template>
	<div>
		<article class="iv2-article" v-if="pageActive">
			<LayoutTitle :title="title" :subtitle="subtitle" />
			<!-- ダウンロード一覧 -->
			<LayoutList :download="download" />

			<!-- ページネーション -->
			<div v-if="last_page > 1" class="container">
				<div class="row clearfix">
					<div class="column full text-center">
						<paginate
							:page-count="last_page"
							:page-range="3"
							:margin-pages="2"
							:click-handler="pagination"
							:prev-text="'＜'"
							:next-text="'＞'"
							:container-class="'pagination d-inline-flex'"
							:page-class="'page-item theme__pagination'"
							:page-link-class="'page-link'">
						</paginate>
					</div>
					<div class="column full">
						<div class="spacer height-100"></div>
					</div>
				</div>
			</div>
		</article>
		<div v-if="loading">
			<BaseLoading />
		</div>
	</div>
</template>

<script>
import LayoutTitle from "./components/LayoutTitle.vue";
import LayoutList from "./components/LayoutList.vue";
import BaseLoading from "@/components/items/BaseLoading.vue";

import Meta from "@/mixins/MetaSettable";
import Preview from "@/mixins/Preview";

export default {
	mixins: [Meta, Preview],

	props: ["animation"],

	components: {
		LayoutTitle,
		LayoutList,
		BaseLoading,
	},

	data() {
		return {
			download: [],
			current_page: 1,
			last_page: 1,
			total: 1,
			from: 0,
			to: 0,
			title: "",
			subtitle: "",

			pageActive: false,
			loading: true,
		};
	},

	mounted() {
		this.load()
	},

	methods: {
		load() {
			if(this.$route.query.mode == 'preview') {
				this.axios.get('/downloads', {
					headers: {
						Authorization: `Bearer ${this.$cookies.get('preview-token')}`,
					},
					params: {
						page: this.sortPage,
					}
				}).then(({data}) => {
					this.download = data.response.data;
					this.current_page = data.response.current_page
					this.last_page = data.response.last_page
					this.total = data.response.total
					this.from = data.response.from
					this.to = data.response.to
					this.title = data.response.title
					this.subtitle = data.response.subtitle
					this.loading = false;
					this.pageActive = true;
					window.scrollTo({
						top: 0,
					});
				}).catch(() => {
					this.loading = false;
					this.pageActive = true;
				});
			}else{
				this.axios.get('/downloads', {
					params: {
						page: this.sortPage,
					}
				}).then(({data}) => {
					this.download = data.response.data;
					this.current_page = data.response.current_page
					this.last_page = data.response.last_page
					this.total = data.response.total
					this.from = data.response.from
					this.to = data.response.to
					this.title = data.response.title
					this.subtitle = data.response.subtitle
					this.loading = false;
					this.pageActive = true;
					window.scrollTo({
						top: 0,
					});
				}).catch(() => {
					this.loading = false;
					this.pageActive = true;
				});
			}
		},

		pagination: function (page) {
			this.loading = true;
			if (page >= 1 && page <= this.last_page) {
				this.sortPage = page
				this.load()
			}
		},
	},
};
</script>

<style lang="scss">
</style>
